import { pragueClock, pragueDateLabel } from '../lib/i18n.js'
import { IconCalendar, IconChevron } from './Icons.jsx'
import StaySlider from './StaySlider.jsx'
import WhenPicker from './WhenPicker.jsx'

/** Home body: a stay of your own and when you arrive. */
export function HomeBody({
  t,
  lang,
  now,
  effectiveDate,
  isOverride,
  setWhen,
  whenOpen,
  setWhenOpen,
  durationMin,
  setDurationText,
}) {
  const whenValue = isOverride
    ? `${pragueDateLabel(effectiveDate, lang)} ${pragueClock(effectiveDate)}`
    : t('whenNow', pragueClock(now))

  return (
    <div className="home">
      <StaySlider t={t} durationMin={durationMin} startDate={effectiveDate} onChange={setDurationText} />

      <section className={`group ${whenOpen ? 'is-open' : ''}`}>
        <button
          type="button"
          className="group__head"
          aria-expanded={whenOpen}
          aria-controls="when-picker"
          onClick={() => setWhenOpen(!whenOpen)}
        >
          <IconCalendar className="group__icon" />
          <span className="group__label">{t('planWhenTitle')}</span>
          <span className={`group__value ${isOverride ? 'is-accent' : ''}`}>{whenValue}</span>
          <IconChevron className="group__chev" />
        </button>
        {whenOpen && (
          <div id="when-picker" className="group__body">
            <WhenPicker t={t} lang={lang} value={effectiveDate} isNow={!isOverride} now={now} onChange={setWhen} />
          </div>
        )}
      </section>
    </div>
  )
}
